import { getBankBranchMaster, ifscRequestBody, ifscResponse } from 'api/nach';

export async function ifscValidator(ifsc: ifscRequestBody): Promise<any> {
  try {
    const res: ifscResponse = await getBankBranchMaster(ifsc);

    if (res.status === 'SUCCESS' && res.data) {
      return res.data;
    }

    return null;
  } catch (error) {
    console.error('Error fetching IFSC:', error);
    return 'not found';
  }
}
